export enum SingleOperators {
  BETWEEN = 'between',
  EQUALS = '==',
  GREATER_THAN = '>',
  GREATER_THAN_OR_EQUAL_TO = '>=',
  LESS_THAN = '<',
  LESS_THAN_OR_EQUAL_TO = '<=',
  LIKE = 'like',
  NOT_LIKE = 'not-like',
  NOT_EQUAL_TO = '!=',
  IS = 'is',
  IS_NOT = 'is-not',
}

export enum ArrayOperators {
  IN = 'in',
  NOT_IN = 'not-in',
}
